<div *ngIf="isOpen()" class="fixed inset-0 z-[1000] bg-black/50" (click)="onBackdropClick()">
    <ng-container *ngComponentOutlet="config()!.component; inputs: config()!.inputs"></ng-container>
</div>
